import React from 'react';
import Dropdown from '../dropdown/Dropdown';
import styled, { css } from '../../styled';
import * as Icons from '../icons';
import * as Button from '../button/Button';
const Selector = styled.div `
  ${props => !props.disabled &&
    css `
      &:hover {
        color: ${({ theme }) => theme.colors.PRIMARY_600};
        box-shadow: 0 0.0625rem 0.125rem 0.0625rem
            ${({ theme }) => theme.colors.SHADOW_DEFAULT},
          0 0 1.5rem 0 ${({ theme }) => theme.colors.SHADOW_LIGHT};
        border-radius: 0.375rem;
      }
    `};

  background-color: ${({ theme }) => theme.colors.SNOW_100};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  box-shadow: ${props => props.disabled
    ? 'none'
    : '0 0.0625rem 0.125rem 0.0625rem rgba(54, 62, 81, 0.1);'}
  border-radius: 0.375rem;

  > button {
    padding: 0 0.5rem;
    border-radius: 0.375rem 0 0 0.375rem;
    box-shadow: none !important;
    border: none;
    display: inline-flex;

    &:not(:active) {
      border: none;
    }
  }
`;
const IconSelectorWrapper = styled.div `
  ${props => props.disabled &&
    css `
      cursor: not-allowed;
    `};

  display: inline-flex;
  align-items: center;
  position: relative;
  &::after {
    content: ' ';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    display: block;
    border-right: 1px solid ${({ theme }) => theme.colors.INK_200};
    margin: 0.25rem 0;
  }
`;
const IconSelector = styled.div `
  ${props => props.disabled &&
    css `
      pointer-events: none;
      background-color: ${({ theme }) => theme.colors[theme.buttons.types.default.disabledBackgroundColor]};
      > svg {
        fill: ${({ theme }) => theme.colors.INK_400};
      }
    `};

  display: inline-flex;
  padding: 0.4375rem 0.375rem;

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.PRIMARY_600};
    border-radius: 0 0.375rem 0.375rem 0;
    > svg {
      fill: ${({ theme }) => theme.colors.PRIMARY_600};
    }
  }

  &:active {
    color: ${({ theme }) => theme.colors.PRIMARY_700};
    > svg {
      fill: ${({ theme }) => theme.colors.PRIMARY_700};
    }
  }
`;
const ButtonDropDown = ({ isOpen, placeHolder, value, options, onButtonClick, onSelectorClick, onChange, onClose, disabled, menuAlign, e2eButtonId, e2eSelectorId, }) => {
    const renderSelector = () => {
        return (React.createElement(Selector, { disabled: disabled },
            React.createElement(Button.Default, { e2eId: e2eButtonId, disabled: disabled, onClick: onButtonClick }, placeHolder),
            React.createElement(IconSelectorWrapper, { "data-e2e-id": e2eSelectorId, disabled: disabled },
                React.createElement(IconSelector, { disabled: disabled, onClick: onSelectorClick },
                    React.createElement(Icons.Outline.Chevron, { size: "MEDIUM", position: isOpen ? 'TOP' : 'BOTTOM' })))));
    };
    return (React.createElement(Dropdown, { options: options, isOpen: isOpen, placeHolder: placeHolder, value: value, onChange: onChange, onClose: onClose, renderSelector: renderSelector, width: "2.9375rem", menuAlign: menuAlign }));
};
export default ButtonDropDown;
//# sourceMappingURL=ButtonDropdown.js.map